import { PersonSupplementaryInsuranceState } from '../../states/offer/offer.state';
import { assertPresent, isNotNullOrUndefined } from '../../utils/typeUtils';
import { CostSharing, Region } from '../../api';
import { ProductConfig, SupplementaryInsuranceConfigurationTexts } from '../supplementary-insurance-configurations';

const mapRegion = (region?: Region): ProductConfig | undefined =>
  region
    ? {
        key: `SUMMARY.SUPPLEMENTARY_INSURANCE.PRODUCT.HOSPITAL.CRITERIA.REGION.${region}`,
      }
    : undefined;

const mapCostSharing = (costSharing?: CostSharing): ProductConfig | undefined =>
  costSharing
    ? {
        key: 'SUMMARY.SUPPLEMENTARY_INSURANCE.PRODUCT.HOSPITAL.CRITERIA.COST_SHARING',
        amount: costSharing,
      }
    : undefined;

export function mapHospitalTexts(
  supplementaryInsurances: PersonSupplementaryInsuranceState,
): SupplementaryInsuranceConfigurationTexts {
  const insurance = assertPresent(supplementaryInsurances.hospital, 'supplementaryInsurances.hospital');

  return {
    productKey: 'HOSPITAL',
    productConfig: [
      {
        key: `SUMMARY.SUPPLEMENTARY_INSURANCE.PRODUCT.HOSPITAL.CRITERIA.HOSPITAL_TYPE.${insurance.offerType}`,
      },
      mapRegion(insurance.region),
      mapCostSharing(insurance.costSharing),
    ].filter(isNotNullOrUndefined),
  };
}

export function mapHospitalVivaTexts(
  supplementaryInsurances: PersonSupplementaryInsuranceState,
): SupplementaryInsuranceConfigurationTexts {
  const insurance = assertPresent(supplementaryInsurances.hospitalViva, 'supplementaryInsurances.hospitalViva');

  return {
    productKey: 'HOSPITAL_VIVA',
    productConfig: [
      {
        key: `SUMMARY.SUPPLEMENTARY_INSURANCE.PRODUCT.HOSPITAL_VIVA.CRITERIA.HOSPITAL_TYPE.${insurance.offerType}`,
      },
      mapRegion(insurance.region),
      mapCostSharing(insurance.costSharing),
    ].filter(isNotNullOrUndefined),
  };
}
